import React, { useState } from "react";
import { FaPen } from "react-icons/fa";
import ModalStructure from "../../ModalStructure";
import ProductSubClassForm from "../../../screens/ProductClasses/ProductSubClasses/ProductSubClassForm";
import SlateEditor from "../../slateEditor/SlateEditor";

const ProductSubClassCard = ({ info, classId, loadToParent }) => {
  const [showSubClassForm, setShowSubClassForm] = useState(false);

  console.log(info);
  return (
    <div className="flex flex-col rounded-xl border-[1px] max-h-[500px] overflow-y-auto max-w-[450px] w-full border-accent-green p-6  shadow-md gap-y-4 font-poppins">
      <div className={`h-[150px] w-auto relative`}>
        <img
          src={`${process.env.REACT_APP_SERVER}${info.image.url}`}
          alt="Cropped example"
          className="w-full h-full object-cover object-center rounded-[5px]"
        />
      </div>
      <div className="w-full flex flex-wrap justify-between items-center">
        <h3 className="font-bold text-dark-green text-wrap text-base">
          {info.name}
        </h3>
        <button
          className="p-2 rounded-full text-dark-green hover:bg-green-50 transition-all duration-100"
          onClick={() => setShowSubClassForm(true)}
        >
          <FaPen />
        </button>
      </div>
      {showSubClassForm && (
        <ModalStructure handleCloseModal={() => setShowSubClassForm(false)}>
          <ProductSubClassForm
            loadToParent={loadToParent}
            prevData={info}
            handleClose={() => setShowSubClassForm(false)}
            classId={classId}
          />
        </ModalStructure>
      )}
      <p className="text-dark-green  text-sm">
        <span className=" font-bold">Descripción:</span> {info.description}
      </p>
      <p className="text-dark-green  text-sm">
        <span className=" font-bold">Descripción larga:</span>{" "}
        {info.longDescription}
      </p>
      <p className=" text-dark-green  text-sm">
        <span className="font-bold">Detalles:</span>
        <SlateEditor
          //la info de details se está trayendo en js en lugar de json
          //una opcion es pasarlo a json
          //la otra es configurar para recibirlo en slateeditor como js o json
          prevValue={info?.details ? JSON.stringify(info.details) : null}
          editable={false}
          customMaxW={"max-w-[435px]"}
          //onChangeData={handleDetailsChange}
        />
      </p>
      {/* <h3 className="text-dark-green text-base font-bold">Categorías: </h3>
      <ul>
        {info.categories?.map((cat, i) => {
          return (
            <li key={i} className="flex flex-row items-center gap-x-2">
              - <span className="text-dark-green text-sm">{cat.category}</span>
            </li>
          );
        })}
      </ul> */}
    </div>
  );
};

export default ProductSubClassCard;
